import { Injectable, Injector } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Resolve,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UlbIMSIPoolStatus } from 'libs/pod-ng-core/src/lib/models/ulb-imsi-pool.class';
import {
  SessionService,
  SessionServiceInjector,
  UlbDeviceStatus,
} from 'pod-ng-core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountUlbEnabledGuardService
  extends SessionServiceInjector
  implements CanActivate {
  constructor(injector: Injector) {
    super(injector);
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return super.session.account?.ulbEnabled;
  }
}

@Injectable({
  providedIn: 'root',
})
export class UlbStockDevicesResolver implements Resolve<any> {
  constructor(private readonly session: SessionService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return of({
      ownerAccountId: this.session.account.id,
      status: UlbDeviceStatus.DISABLED,
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class UlbDevicesResolver implements Resolve<any> {
  constructor(private readonly session: SessionService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return of({
      accountId: this.session.account.id,
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class UlbStockIMSIPoolResolver implements Resolve<any> {
  constructor(private readonly session: SessionService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return of({
      accountId: this.session.account.id,
      status: UlbIMSIPoolStatus.INACTIVE,
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class UlbIMSIPoolResolver implements Resolve<any> {
  constructor(private readonly session: SessionService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return of({
      ownership: this.session.account.id,
    });
  }
}
